/**
 * @generated SignedSource<<2048946d67acd1895a7b974c84371683>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpCreatorItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer" | "NftItemTile_viewer">;
  readonly " $fragmentType": "NftPdpCreatorItems_viewer";
};
export type NftPdpCreatorItems_viewer$key = {
  readonly " $data"?: NftPdpCreatorItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpCreatorItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpCreatorItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a3e3a5159980b28dc08dbc9de31199d8";

export default node;
